import { SkillSetSpec } from '../skillsets/skill-set-spec'
import { WorkAction } from '../../../shopfloor/workcenters/capability/capabilities/work-action'

export class CapabilitySpec {
  public id: string

  public name: string

  public actionSequence: WorkAction[] = []

  public skillSets: SkillSetSpec[] = []

  public description: string
}
